import { render, staticRenderFns } from "./FormQuestionRadioButtonType.vue?vue&type=template&id=5b6279a8"
import script from "./FormQuestionRadioButtonType.vue?vue&type=script&lang=js"
export * from "./FormQuestionRadioButtonType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/CoreProductivity.Backoffice.Mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b6279a8')) {
      api.createRecord('5b6279a8', component.options)
    } else {
      api.reload('5b6279a8', component.options)
    }
    module.hot.accept("./FormQuestionRadioButtonType.vue?vue&type=template&id=5b6279a8", function () {
      api.rerender('5b6279a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/pages/form/FormApp/FormQuestionRadioButtonType.vue"
export default component.exports